export const standardTableCustomFunction = (rowData, cell, value, colName) => {
  if (!rowData.attributes) {
    return
  }

  const attr = rowData.attributes

  const bgColors = attr.bgColor || {}
  const bgColor = bgColors[colName]
  if (bgColor) {
    cell.style.backgroundColor = bgColor
  }

  const fgColors = attr.fgColor || {}
  const fgColor = fgColors[colName]
  if (fgColor) {
    cell.style.color = fgColor
  }
}

/**
 * CellにクリックでGoogle検索を行うイベントを付与
 */
export const searchCellCustomFunction = (rowData, cell, value, colName) => {
  // API側で作ったgoogle_search_wordsを取得する。
  const googleSearchWords = rowData.google_search_words[colName]
  // 検索ワードが無ければ返す
  if (googleSearchWords) {
    // 検索リンクCSSを設定
    cell.classList.add('google-search-cell')

    // テキスト取得してイベントをセットする
    cell.setAttribute('data-code-name', formatSearchText(googleSearchWords))
    cell.addEventListener('click', e => {
      const searchText = e.target.getAttribute('data-code-name')
      if (!searchText) {
        throw new Error('SearchText not found')
      }
      // 別タブで検索画面を開く
      openSearchGoogle(searchText)
    })
  }
}

/**
 * 検索ワードをフォーマット:"(item_code) OR (item_name)"
 */
export const formatSearchText = googleSearchWords => {
  return googleSearchWords.map(m => `(${m})`).join(' OR ')
}

/**
 * 別タブでGoogle検索を開く
 */
export const openSearchGoogle = searchText => {
  const searchUrl = 'https://www.google.com/search?q=' + searchText
  window.open(searchUrl, '_blank')
}

/**
 * ２つの関数を行う
 */
export const standardWithSearchCustomFunction = (
  rowData,
  cell,
  value,
  colName,
) => {
  standardTableCustomFunction(rowData, cell, value, colName)
  searchCellCustomFunction(rowData, cell, value, colName)
}
